var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.username === '' && _vm.roomId === '')?_c('Login',{on:{"join":_vm.join}}):_c('Chatroom',{attrs:{"username":_vm.username,"roomId":_vm.roomId},on:{"exit":_vm.exit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }